module.exports = __webpack_public_path__ + "static/media/bg.fa4c4070.png";